import React from "react";

import { css, cx } from "@emotion/css";
import Typography from "@mui/material/Typography";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseFormInputErrorProps = {
  errorMessage?: string;
  /**
   * The error message will no longer overflow and will take its supposed space
   */
  reserveSpace?: boolean;
};

export type FormInputErrorProps = AtomProps<BaseFormInputErrorProps, StyleClasses<"root">>;

export const FormInputError: React.FC<FormInputErrorProps> = ({
  id,
  reserveSpace,
  errorMessage = " ",
  className,
  classes,
  ...props
}) => {
  const styles = useStyles(makeStyles);

  return (
    <div
      id={id}
      className={cx(
        {
          [styles.root]: true,
          [styles.rootWithSpace]: reserveSpace,
        },
        className,
      )}
      {...props}
    >
      <Typography variant="caption" color="error" className={styles.text}>
        {errorMessage}
      </Typography>
    </div>
  );
};

const makeStyles = (theme: Theme) => ({
  root: css({
    height: theme.spacing(0),
  }),
  rootWithSpace: css({
    height: theme.spacing(12),
    overflow: "clip",
  }),
  text: css({
    lineHeight: 0,
  }),
});
